export default {
  associate: undefined,
  managerScopeObjects: undefined,
  associateKPI: undefined,
  associateAttendanceRate: undefined,
  associateCompliance: undefined,
  associateCertification: undefined,
  associateChangesHistory: [],

  associateWriteUps: [],
  associateFacilities: undefined,
  signedDocuments: [],
  associateCompanyFlow: undefined,
  associateLifecycleEvents: undefined,

  refetchAssociate: false
}
